<template>
 <section id="section-home" class="appear carousel carousel-fade slide" data-ride="carousel" data-interval="5000" data-pause="hover">
			<!-- <div class="item">
				<div class="container-fluid">
					<div class="row home-top1">
						<div class="col-sm-12 text-center">
							<img src="../assets/img/logoword.png" draggable="false" class="animation203 animated fadeInDown img-responsive center-block">
							<br>
							<br>
							<br>
							<p class="carouselText3 animation203 animated fadeInUp" style="color: #404040;">
								往下滚动，了解更多 ^_^
							</p>
						</div>
					</div>
				</div>
			</div> -->
			<div id="frameload" class="container">
				<div style='height: 700px;width: 100%;position: absolute;z-index: 2;'>
					<img src='../assets/img/logoword2.png' class='img-responsive center-block notransition animated fadeInUpNow animation103' style='margin-top: 350px;padding-left: 20px;padding-right: 20px;'>
				</div>
				<div style="width:100%;margin: 0 auto;z-index: 0;height:700px;background-size:100% auto;" class="divload"></div>
			</div>
			<div id="mice">
				<a href="#section-about" class="smooth">
					<div>
						<span class="unu"></span>
						<span class="doi"></span>
					</div>
				</a>
			</div>
		</section>
</template>

<style scoped>
@import "../assets/css/carousel.css";
</style>

<script>
export default {
  name: 'Home'
}
</script>